import React from 'react';
import { motion } from 'framer-motion';
import { TicketIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/mfEToWmqsyib48WpQG8oz2/VU_AbbeyRoad_HiRes.jpg';
export function Hero() {
  return <header id="top" className="relative w-full min-h-[calc(100svh-64px)] overflow-hidden bg-[var(--vu-black)]" data-id="element-42" data-mp="9llat1xpw6pm">
      <div className="absolute inset-0 z-0" data-id="element-43" data-mp="4n9wof0e3a1l">
        <img src={HERO_IMG} alt="Virtually Unknown crossing Abbey Road with their instruments" className="h-full w-full object-cover object-[center_18%]" data-id="element-44" data-mp="1297aw07qkt7q" />
        {/* Soft contrast zones sit only in the open canopy and crossing; all four faces remain unobstructed. */}
        <div className="absolute inset-x-0 top-0 h-[31%] bg-gradient-to-b from-[var(--vu-black)]/45 to-transparent" data-id="element-45" data-mp="ncq31iyr9wpx" />
        <div className="absolute inset-x-0 bottom-0 h-[34%] bg-gradient-to-t from-[var(--vu-black)] via-[var(--vu-black)]/84 to-transparent" data-id="element-46" data-mp="3d2l9jc5qb50p" />
      </div>

      <div className="relative z-10 flex min-h-[calc(100svh-64px)] flex-col justify-between px-5 py-7 sm:px-8 sm:py-10" data-id="element-47" data-mp="3j8iyd2s0imwa">
        {/* Positioned in the open sky and tree canopy above the band. */}
        <motion.div initial={{
        opacity: 0,
        y: -14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} className="mx-auto w-full max-w-4xl pt-1 text-center" data-id="element-48" data-mp="3o59a5dwsawbw">
          <h1 className="font-display -rotate-1 text-4xl uppercase leading-[0.88] tracking-[0.02em] text-[var(--vu-red)] [text-shadow:3px_3px_0_var(--vu-navy),-1px_-1px_0_var(--vu-gold),1px_-1px_0_var(--vu-gold),-1px_1px_0_var(--vu-gold),1px_1px_0_var(--vu-gold)] sm:text-6xl md:text-7xl" data-id="element-49" data-mp="30hre366hlc34">
            Virtually Unknown
          </h1>
          <p className="mt-2 font-cond text-sm uppercase tracking-[0.3em] text-[var(--vu-cream)] [text-shadow:0_1px_2px_rgba(0,0,0,0.95),0_0_8px_rgba(0,0,0,0.8),0_0_14px_rgba(0,0,0,0.55)] sm:text-base" data-id="element-50" data-mp="2vj7uhcfd8cdx">
            Old Dogs. New Tricks.
          </p>
        </motion.div>

        {/* Low information panel is reserved for the street/crossing, away from all faces. */}
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.12,
        duration: 0.55,
        ease: 'easeOut'
      }} className="mx-auto w-full max-w-2xl border-y border-[var(--vu-gold)]/65 bg-[var(--vu-black)]/78 px-5 py-5 text-center shadow-[0_10px_30px_rgba(0,0,0,0.25)] backdrop-blur-[2px] sm:px-9" data-id="element-51" data-mp="naa0aponrglg">
          <p className="font-cond text-xs uppercase tracking-[0.34em] text-[var(--vu-gold)] sm:text-sm" data-id="element-52" data-mp="161az9dps3c50">
            St. Pete Beach · Florida
          </p>
          <p className="mt-2 font-body text-sm text-[var(--vu-cream)]/80 sm:text-base" data-id="element-53" data-mp="114sw2ia3jlus">
            Classic Rock · Acoustic · Pop · Rock
          </p>
          <div className="mt-5" data-id="element-54" data-mp="3lt76ct9j5vvb">
            <a href="#shows" className="group inline-flex items-center gap-3 border-2 border-[var(--vu-gold)] bg-[var(--vu-red)] px-8 py-4 font-display text-lg uppercase tracking-wider text-[var(--vu-cream)] shadow-[5px_5px_0_0_var(--vu-black)] transition-all hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[2px_2px_0_0_var(--vu-black)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--vu-gold)]" data-id="element-55" data-mp="3lui70k7oini7">
              <TicketIcon className="h-5 w-5" data-id="element-56" data-mp="2b2sn8h9om60h" />
              Catch Us Live
            </a>
          </div>
        </motion.div>
      </div>
    </header>;
}